<script>

  import signOut from './sign-out.vue'
  import gql from 'graphql-tag'
  const findUser = gql`
    query findUser($id: String) {
      user: contexte_usager(id: $id) {
        id
        # email
        nom
        prenom
      }
    }
  `
  export default {
    name: 'UserInfo',
    props: {
      id: {},
    },
    data () {
      return {
        user: null,
      }
    },
    components: {
      signOut,
    },
    apollo: {
      user: {
        // returnPartialData: true,
        query: findUser,
        variables () {
          return {
            id: this.id,
          }
        },
        skip () {
          return !this.id
        },
      },
    },
  }
</script>

<template lang="pug">

div.user-info
  h3.b.f3(v-if="user") {{user.prenom}} {{user.nom}}
  sign-out
</template>

<style lang="postcss" scoped>

  .user-info {
      /*background: black;*/
  }

</style>



// WEBPACK FOOTER //
// user-info.vue?5be79f70